import { connect } from 'react-redux';
import SiteListing from './siteListing';
import { bindActionCreators } from 'redux';
import {
  getSiteListing,
  getSiteFilters,
  getLocationChange,
  UploadFlat,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.siteListData,
  siteFilters: state.siteListingReducer.siteFiltersData,
  locationChange: state.siteListingReducer.locationChange,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListing,
      getSiteFilters,
      getLocationChange,
      UploadFlat,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteListing);
